import * as React from 'react';
import Text from '../Text';
import {ListingProviderType} from '../../models/enums';
import {PersonaProps} from './types';
import airbnbBadge from '../../images/airbnb-badge.svg';
import bookingBadge from '../../images/booking-badge.svg';
import vrboBadge from '../../images/vrbo-badge.svg';

const badgeDefaultStyle = {
  width: 12,
  marginLeft: 5
};

export default class Persona extends React.Component<PersonaProps, {}> {
  public render() {
    const {children, badge, badgeClassName, badgeStyle, ...restProps} = this.props;

    return (
      <Text {...restProps}>
        {children}
        {badge && this._badgeImage ? (
          <img src={this._badgeImage} className={badgeClassName} style={{...badgeDefaultStyle, ...badgeStyle}} />
        ) : null}
      </Text>
    );
  }

  private get _badgeImage() {
    const {badge} = this.props;

    switch (badge) {
      case ListingProviderType.AIRBNB:
        return airbnbBadge;
      case ListingProviderType.BOOKING:
        return bookingBadge;
      case ListingProviderType.VRBO:
        return vrboBadge;
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Persona/Persona.tsx